module.exports = __webpack_public_path__ + "static/media/marvin.6660550e.png";